import { createStyles } from 'antd-style'

export default createStyles(() => {
  return {
    modalContent: {},
    formWrapper: {},
  }
})
